import React, { Fragment } from 'react';
import Helmet from 'react-helmet';
import { ThemeProvider } from 'styled-components';
import { theme } from '@upsolve/ui';

import config from '../../../site-config';
import GlobalStyle from '../GlobalStyle';
import ChatWidget from '../Widgets/ChatWidget';
import UserFacesSpaced from '../backgrounds/UserFacesSpaced';

export default class TopLevelLayout extends React.Component {
  componentDidMount() {
    // for the dev cred
    console.log(`
██████████████████████████████████████████████████████████

██╗   ██╗██████╗ ███████╗ ██████╗ ██╗    ██╗   ██╗███████╗
██║   ██║██╔══██╗██╔════╝██╔═══██╗██║    ██║   ██║██╔════╝
██║   ██║██████╔╝███████╗██║   ██║██║    ██║   ██║█████╗
██║   ██║██╔═══╝ ╚════██║██║   ██║██║    ╚██╗ ██╔╝██╔══╝
╚██████╔╝██║     ███████║╚██████╔╝███████╗╚████╔╝ ███████╗
 ╚═════╝ ╚═╝     ╚══════╝ ╚═════╝ ╚══════╝ ╚═══╝  ╚══════╝

██████████████████████████████████████████████████████████

👋 Yo!
👩‍💻 Would you like to:

⚬ Improve access to an under-utilized social safety net?
⚬ Create a countering force to predatory lenders?
⚬ Change the perception of what a nonprofit can do?
⚬ Get in a good kind of a trouble?

📬 Email: mark@upsolve.org

██████████████████████████████████████████████████████████
    `);
  }

  render() {
    const showPersistentCta = this.props.showPersistentCta != null ? this.props.showPersistentCta : true;
    const showBackground = this.props.showBackground != null ? this.props.showBackground : false;
    const persistentCtaText = this.props.persistentCtaText || 'Get Your Fresh Start';
    const backgroundTemplate = this.props.backgroundTemplate;

    return (
      <Fragment>
        <GlobalStyle />
        <Helmet>
          <title>{config.siteTitle}</title>
          <meta name="description" content={config.siteDescription} />
        </Helmet>
        <ThemeProvider theme={theme}>
          <Fragment>
            {this.props.children}
            <ChatWidget showPersistentCta={showPersistentCta} persistentCtaText={persistentCtaText} />
            {showBackground && (
              <Fragment>
                {backgroundTemplate === 'userFacesSpaced' && false && <UserFacesSpaced />}
              </Fragment>
            )}
          </Fragment>
        </ThemeProvider>
      </Fragment>
    );
  }
}
